import './loaderbtn.scss'

type Prop={
    className:string,
    text:string,
    isLoading:boolean,
    spinnerBackColor?:string
    spinnerForeColor?:string,
    thickness?:number,
    size?:number,
    spinnerSpeed?:number,
    clickFunction?:()=> void,
    disabled?:boolean
}


const LoaderBtn=({className,text,isLoading,spinnerBackColor,spinnerForeColor,thickness,size,spinnerSpeed,disabled,clickFunction}:Prop)=>{


    const clickHandler=()=>{
        
        if(disabled) return

        if(clickFunction){
           clickFunction()
        }

    }
    


return (<button className={`${className} loaderbtn`} onClick={clickHandler}>
<div>{text}</div>
{isLoading && (
    <div className={`spinner `}  style={
    {
    border:`${thickness? thickness : '2'}px solid ${spinnerBackColor? spinnerBackColor : 'rgba(255,255,255,0.5)' }`,
    borderTop:`${thickness? thickness : '2'}px solid ${spinnerForeColor? spinnerForeColor : 'rgba(255,255,255,1)' }`,
    width:`${size?size:'23'}px`,
    height:`${size?size:'23'}px`,
    animation:`spin ${spinnerSpeed?spinnerSpeed:'0.5'}s linear infinite`
    }}
    ></div>)}
</button>)
}

export default LoaderBtn